/**
 * Map a failed Open SSO request to the message an admin should see.
 *
 * Extracted because the same three-branch mapping was written out verbatim in
 * three places (the reports controller, OpenSsoView, and now the shared confirm
 * flow), and a fourth copy is how the wording drifts.
 *
 * The 403 is the interesting branch: `admin:sso:open` is delegable, so plenty
 * of perfectly valid admins do not hold it and will hit this. The message says
 * what is missing without implying the member or the FI is at fault.
 *
 * @param {*} error An axios error, or anything else that was thrown.
 * @returns {string}
 */
export function ssoErrorMessage(error) {
    switch (error?.response?.status) {
        case 403:
            return 'You do not have access to do that for this FI.';
        case 404:
            // The session endpoint 404s both for an unknown member and for one
            // with no stored SSO context (code NO_SSO_CONTEXT). Both mean the
            // same thing to the admin: this member cannot be entered.
            return 'This user cannot be opened in SSO.';
        default:
            return 'Could not open the consumer app for this user.';
    }
}

export default ssoErrorMessage;
